import L from "leaflet";
import * as React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import Avatar from "@mui/material/Avatar";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

var specialEventIcon = L.icon({
  iconUrl:
    process.env.PUBLIC_URL + "/mapicons/SpecialEvents/Special_Event_v14.png",

  iconSize: [21, 21], // size of the icon
  popupAnchor: [0, 0], // point from which the popup should open relative to the iconAnchor
});

const getLeafletIcon = (feature, latlng, map, pane) => {
  var title = " Special Event - " + getDesc(feature.properties);
  return L.marker(latlng, {
    icon: specialEventIcon,
    title: title,
    alt: title,
    pane: pane,
  });
};

const getDesc = (properties) => {
  return properties.dec;
};

const PopupTemplate = (props) => {
  const feature = props.feature;
  return <SpecialEvent feature={feature} />;
};

const SpecialEvent = (props) => {
  const feature = props.feature;
  const properties = feature.properties;
  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardHeader
        avatar={
          <Avatar
            alt="Special Event"
            src={
              process.env.PUBLIC_URL +
              "/mapicons/SpecialEvents/Special_Event_v14.png"
            }
            sx={{ width: 21, height: 21 }}
            aria-label="specialevent"
          ></Avatar>
        }
        title={<font className="layer-title"> Special Event </font>}
        className="styledtablerow"
        sx={{ pb: 0, paddingTop: 1, paddingBottom: 0, paddingLeft: 1 }}
      />
      <CardContent
        size="small"
        sx={{
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 1,
          paddingRight: 1,
          marginBottom: -3,
        }}
      >
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell className={"layertablecellLeft"}>
                <div>{properties.locDesc}</div>
                <span dangerouslySetInnerHTML={{ __html: properties.desc }} />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Table size="small" style={{ cellSpacing: 0 }}>
          <TableBody>
            <TableRow className="styledtablerow">
              <TableCell className={"layertablecellLeft"}>
                Closure&nbsp;Details
              </TableCell>
              <TableCell className={"layertablecellRight"}>
                {properties.closure}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={"layertablecellLeft"}>
                Time Period
              </TableCell>
              <TableCell className={"layertablecellRight"}>
                {properties.time}
              </TableCell>
            </TableRow>
            <TableRow className="styledtablerow">
              <TableCell className={"layertablecellLeft"}>Duration</TableCell>
              <TableCell className={"layertablecellRight"}>
                {properties.dur}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={"layertablecellLeft"}>Severity</TableCell>
              <TableCell className={"layertablecellRight"}>
                {properties.sev}
              </TableCell>
            </TableRow>
            <TableRow className="styledtablerow">
              <TableCell className={"layertablecellLeft"}>Source</TableCell>
              <TableCell className={"layertablecellRight"}>
                {properties.src}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell className={"layertablecellLeft"}>
                Last Updated
              </TableCell>
              <TableCell className={"layertablecellRight"}>
                {properties.lstUpd}
              </TableCell>
            </TableRow>
            {properties.mo && (
              <TableRow className="styledtablerow">
                <TableCell className={"layertablecellLeft"}>
                  Moving Operation
                </TableCell>
                <TableCell className={"layertablecellRight"}>
                  {String(properties.mo)}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

const style = {
  weight: 5,
  opacity: 0.9,
  color: "#A020F0",
  lineCap: "square",
};

const isFullClosure = (feature) => {
  return (
    feature.properties.closure.toLowerCase() ===
    "all lanes and shoulders closed"
  );
};

/** strings currently being produced as part of the closures field:
 * "All lanes and shoulders closed"
 * "All lanes and shoulders open"
 * "Left lane and left shoulder closed, one lane open"
 */
const hasClosure = (feature) => {
  const closureStr = feature.properties?.closure;
  if (!closureStr) return false;
  const lower = closureStr.toLowerCase();
  if (lower.includes("closed")) return true;
  if (lower.includes("open") && !lower.includes("closed")) return false;
  return false;
};

const onEachFeature = (feature, layer) => {
  if (feature.geometry.geometries.length > 1) {
    let idx = 0;
    layer.eachLayer((layer) => {
      const layerfeature = feature.geometry.geometries[idx];
      if ("MultiLineString" === layerfeature.type) {
        if (isFullClosure(feature)) {
          layer.setStyle(style);
        } else {
          layer.setStyle(style);
        }
      }
      idx++;
    });
  }
};

const module = {
  name: "Special Event",
  endpoint: "/specialEventMap.json?type=lines",
  showOnMap: true,
  getLeafletIcon: getLeafletIcon,
  PopupTemplate: PopupTemplate,
  updateDelay: 180,
  mapLayerIcon:
    process.env.PUBLIC_URL + "/mapicons/SpecialEvents/Special_Event_v14.png",
  maxZoom: 9,
  zIndex: 625,
  onEachFeature: onEachFeature,
  hasClosure: hasClosure,
};

export default module;
